import { PageType, UserRole } from '../enums'

const isValidUser = (user: IUserInfo, pageType: PageType): boolean => {
  if (!user) {
    return false
  }
  if (user.role === UserRole.SUPER_ADMIN) {
    return true
  }
  return !!(user.role === UserRole.REGULAR_USER && pageType !== PageType.ADMIN)
}

export const permissionMatrix = {
  isValidUser,
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/core/permissionMatrix.ts